import { render, staticRenderFns } from "./Information.vue?vue&type=template&id=00db9f39&scoped=true"
import script from "./Information.vue?vue&type=script&setup=true&lang=ts"
export * from "./Information.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Information.vue?vue&type=style&index=0&id=00db9f39&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00db9f39",
  null
  
)

export default component.exports